import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import 'react-phone-input-2/lib/style.css';
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment/moment';
import { toast } from 'react-toastify';

const DependentDetails = ({ setDependentList, countriesList, dependentList, addAddressType, readOnly = false }) => {
    const apiService = new LeaseApiService();
    const [editIndex, setEditIndex] = useState(null);
    const [cityList, setCityList] = useState([]);

    const [formData, setFormData] = useState({
        type: null,
        name: '',
        email: '',
        address: '',
        mobileNo: '',
        passport: '',
        age: '',
        poBox: '',
        occupation: '',
        dateofBirth: '',
        nationality: null,
        country: null,
        city: null,
        gender: null,
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    }

    const relation = [
        { value: "father", label: "Father" },
        { value: "mother", label: "Mother" },
        { value: "spouse", label: "Spouse" },
        { value: "son", label: "Son" },
        { value: "daughter", label: "Daughter" },
        { value: "brother", label: "Brother" },
        { value: "sister", label: "Sister" },
        { value: "grandfather", label: "Grand Father" },
        { value: "grandmother", label: "Grand Mother" },
        { value: "uncle", label: "Uncle" },
        { value: "aunt", label: "Aunt" },
        { value: "cousin", label: "Cousin" },
        { value: "guardian", label: "Guardian" },
        { value: "other", label: "Other" }
    ]
    const genderOptions = [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
        { value: "O", label: "Other" },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected) => {
        setFormData(prev => ({ ...prev, type: selected }));
    };

    const handleAddOrUpdate = () => {

        if (!formData?.type) {
            toast.warning("Please Select Relation type")
            return
        } else if (!formData?.name) {
            toast.warning("Please Enter Name")
            return
        }

        if (editIndex !== null) {
            // UPDATE
            const updatedList = [...dependentList];
            updatedList[editIndex] = formData;
            setDependentList(updatedList);
            setEditIndex(null);
        } else {
            // ADD
            setDependentList(prev => [...prev, formData]);
        }

        setFormData({
            type: null,
            name: '',
            email: '',
            address: '',
            mobileNo: '',
            passport: '',
            age: '',
            poBox: '',
            occupation: '',
            dateofBirth: '',
            nationality: null,
            country: null,
            city: null,
            gender: null,
        });
    };

    const handleEdit = (index) => {
        setFormData(dependentList[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        const filtered = dependentList.filter((_, i) => i !== index);
        setDependentList(filtered);
    };

    const handleNationalityChange = async (selectedOption) => {
        setFormData(prev => ({ ...prev, nationality: selectedOption, city: null }));
    }
    const handleCountryChange = async (selectedOption) => {
        setCityList([])
        const params = new URLSearchParams();
        params.append('DropdownFor', 'CustCityDescByCountry');
        params.append('CascadText', selectedOption?.label);
        setFormData(prev => ({ ...prev, country: selectedOption, city: null }));
        const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
        setCityList(res?.data?.items)
    }
    const handleCityChange = (selectedOption) => {
        setFormData(prev => ({ ...prev, city: selectedOption }));
    }
    const handleGender = (selectedOption) => {
        setFormData(prev => ({ ...prev, gender: selectedOption }));
    }

    const handleDateChange = (input) => {
        const value = input?.target?.value || input.value;
        const name = input?.target?.name || input.name;
        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        setFormData(prev => ({ ...prev, [name]: updatedValue }));
    }
    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
                {!readOnly && (
                <>
                <div className="form-group grid-contain ">
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Relation Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={relation}
                            // options={addAddressType?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.type}
                            onChange={handleSelectChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Name</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Nationality</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData?.nationality}
                            onChange={handleNationalityChange}
                            options={countriesList?.map(country => ({ value: country?.value, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Gender</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData?.gender}
                            onChange={handleGender}
                            options={genderOptions}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Email</label>
                        <input
                            type="email"
                            className="p-2 form-control w-75"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Country</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData?.country}
                            onChange={handleCountryChange}
                            options={countriesList?.map(country => ({ value: country?.value, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Age</label>
                        <input
                            type="number"
                            className="p-2 form-control w-75"
                            name="age"
                            value={formData.age}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Mobile No</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="mobileNo"
                            value={formData.mobileNo}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">City</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData?.city}
                            onChange={handleCityChange}
                            options={cityList?.map(country => ({ value: country?.value, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Address</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Birth Date</label>
                        <DatePicker
                            selected={formData.dateofBirth}
                            onChange={(date) => handleDateChange({ name: 'dateofBirth', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">P.O Box</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="poBox"
                            value={formData.poBox}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">ID/Passport No</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="passport"
                            value={formData.passport}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Occupation</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="occupation"
                            value={formData.occupation}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className='my-4'>
                    <div
                        className='mainbtnSecondary flex-end gap-2 col-2'
                        style={{ cursor: "pointer" }}
                        onClick={handleAddOrUpdate}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update Contact" : "Add Contact"}
                        </div>
                    </div>
                </div>
                </>
                )}

                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                {!readOnly && <th>Action</th>}
                                <th>Type</th>
                                <th>Name</th>
                                <th>email</th>
                                <th>Mobile No</th>
                                <th>ID/Passport No</th>
                                <th>Nationality</th>
                                <th>Country</th>
                                <th>City</th>
                                <th>Address</th>
                                <th>Gender</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dependentList.map((data, index) => (
                                <tr key={index}>
                                    {!readOnly && (
                                    <td className="text-center d-flex gap-3">
                                        <div className='center mt-2'>
                                            <FaEdit
                                                size={20}
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => handleEdit(index)}
                                            />
                                        </div>
                                        <div className='center mt-2'>
                                            <FaTrash
                                                size={20}
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => handleDelete(index)}
                                            />
                                        </div>
                                    </td>
                                    )}
                                    <td>{data.type?.label}</td>
                                    <td>{data.name}</td>
                                    <td>{data.email}</td>
                                    <td>{data.mobileNo}</td>
                                    <td>{data.passport}</td>
                                    <td>{data.nationality?.label}</td>
                                    <td>{data.country?.label}</td>
                                    <td>{data.city?.label}</td>
                                    <td>{data.address}</td>
                                    <td>{data.gender?.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default DependentDetails;
